import { useEffect } from 'react';

const SmartSuppChat = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.innerHTML = `
            var _smartsupp = _smartsupp || {};
            _smartsupp.key = 'fd75eb42838db308546a5d60608fba9ca3ae3251';
            window.smartsupp||(function(d) {
            var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[];
            s=d.getElementsByTagName('script')[0];c=d.createElement('script');
            c.type='text/javascript';c.charset='utf-8';c.async=true;
            c.src='https://www.smartsuppchat.com/loader.js?';s.parentNode.insertBefore(c,s);
            })(document);
        `;
        document.body.appendChild(script);
    }, []);

    return null; 
};

export default SmartSuppChat;
